import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initUiTheme } from './uiTheme';
import { installCsrfFetch } from './csrfFetch';
import App from './App';

installCsrfFetch();
initUiTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
